let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jAFOa")).then(() => parcelRequire('5JTJm'));